import jsPDF from "jspdf";

import { drawHeader } from "../../../../component/WGRHeader";
import { drawFooter } from "../../../../component/WGRFooter";
import { drawShopTable } from "./wasummeryPDFTable";
import {
  handlePdf,
  PDF_ACTION,
} from "../../../../../../utils/pdfHelper";

export default function generateWGRPDF(
  title,
  rows = [],
  month,
  year
) {
  const doc = new jsPDF({
    orientation: "l",
    unit: "mm",
    format: "a4",
  });

  /*
   * ==========================================
   * GET SUMMARY DATA
   * ==========================================
   *
   * Your API currently returns:
   *
   * rows[0] = {
   *   labour,
   *   store,
   *   freight,
   *   proforma,
   *   jv5,
   *   jv6,
   *   jv7,
   *   ...
   * }
   */

  const totals = rows || {};



  // console.log(
  //   "Workshop Account PDF totals:",
  //   totals
  // );

  /*
   * ==========================================
   * HEADER
   * ==========================================
   */

  drawHeader(
    doc,
    month,
    year,
   // title
  );

  /*
   * ==========================================
   * WORKSHOP ACCOUNT TABLE
   * ==========================================
   */

  drawShopTable(
    doc,
    totals,
    month,
    year
  );

  /*
   * ==========================================
   * FOOTER
   * ==========================================
   */

  drawFooter(
    doc,
    month,
    year,
    title
  );

  /*
   * ==========================================
   * VIEW PDF
   * ==========================================
   */

  handlePdf(
    doc,
    PDF_ACTION.VIEW
  );
}